import React from 'react';
import { ThingToDoComponentProps, ThingToDoTile, useThingToDo } from '.';
import { useThingsToDoTelemetry } from './ThingsToDo.telemetry';

export const ThingToDoClean: React.FC<ThingToDoComponentProps> = props => {
  const telemetry = useThingsToDoTelemetry();
  const { constructCampaignUrl } = useThingToDo();

  const handleCleanClick = () => {
    telemetry.thingsToDoCTAClicked(props.url, {
      componentName: 'ThingToDoClean',
      url: props.url,
      thingToDoName: props.title,
      city: props.location,
      tours: props.tours,
    });

    window.open(constructCampaignUrl(props.url), '_blank', 'noopener');
  };

  return (
    <ThingToDoTile
      onClick={handleCleanClick}
      {...props}
    />
  );
};
